import React from "react";
import "./App.css";
import { BrowserRouter, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Culture from "./components/Culture";
import Product from "./components/Products";

function App() {
  return (
    <BrowserRouter>
      <div className="container-fluid m-0 p-0">
        <Header />
        <Route exact path="/" component={Culture} />
        <Route exact path="/culture" component={Culture} />
        <Route exact path="/products" component={Product} />

        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
